import scroll_magic_animation from "../../js/src/scroll-magic";
import slick_slider from "../../js/src/slick-sliders";

class media_carousel {
    media_carousel_config = {
        settings: {
            v_landscape: {
                dots: true,
                arrows: false,
                infinite: true,
                speed: 300,
                slidesToShow: 2,
                adaptiveHeight: true,
                appendDots: null,
                variableWidth: false,
                focusOnSelect: true,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            variableWidth: true
                        }
                    }
                ]
            },
            v_portrait: {
                dots: true,
                arrows: false,
                infinite: true,
                speed: 300,
                slidesToShow: 4,
                adaptiveHeight: true,
                appendDots: null,
                variableWidth: false,
                focusOnSelect: true,
                responsive: [
                    {
                        breakpoint: 1528,
                        settings: {
                            slidesToShow: 3,
                            variableWidth: true
                        }
                    },
                    {
                        breakpoint: 1025,
                        settings: {
                            slidesToShow: 2,
                            variableWidth: true
                        }
                    }
                ]
            },
            i_portrait: {
                dots: true,
                arrows: false,
                infinite: true,
                speed: 300,
                slidesToShow: 4,
                adaptiveHeight: true,
                appendDots: null,
                variableWidth: false,
                responsive: [
                    {
                        breakpoint: 1528,
                        settings: {
                            slidesToShow: 3,
                            variableWidth: true
                        }
                    },
                    {
                        breakpoint: 1025,
                        settings: {
                            slidesToShow: 2,
                            variableWidth: true
                        }
                    }
                ]
            },
            i_landscape: {
                dots: true,
                arrows: false,
                infinite: true,
                speed: 300,
                slidesToShow: 2,
                adaptiveHeight: true,
                appendDots: null,
                variableWidth: false,
                focusOnSelect: true,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            variableWidth: true
                        }
                    }
                ]
            }
        },
        sliders: [],
        players: [],
        videos: []
    }

    constructor() {
        this.media_carousel_slider_init();
        this.media_carousel_video_init();
    }

    /* Disable cloned iframe src so duplicate players never initialize */
    media_carousel_strip_clone_embeds($slider) {
        $slider.find('.slick-cloned iframe[src]').each(function() {
            const $iframe = $(this);
            $iframe.attr('data-src', $iframe.attr('src'));
            $iframe.removeAttr('onload');
            $iframe.removeAttr('src');
        });
    }

    media_carousel_slider_init() {
        // Set global context outside of loop
        let _t = this;

        $('[block-name="media-carousel"]').each(function(i, e) {
            // Set slider config
            let media_carousel_config = ($(e).data('content-type') === 'video')
                ? ($(e).data('image-type') === 'portrait' ? _t.media_carousel_config.settings.v_portrait : _t.media_carousel_config.settings.v_landscape)
                : ($(e).data('image-type') === 'portrait' ? _t.media_carousel_config.settings.i_portrait : _t.media_carousel_config.settings.i_landscape);

            // Set slider element per block
            let $media_carousel_slider = $(e).find('.media-carousel__slider');

            _t.media_carousel_config.sliders.push($media_carousel_slider);

            // Bind animation to card carousel
            let $media_carousel_animation = new scroll_magic_animation($media_carousel_slider, 'animate--slide-right--double');

            // Bind dots to slick dots component
            let $media_carousel_dots = $(e).find('.slick-slider__dots');

            // Bind card carousel dots to sick element
            media_carousel_config.appendDots = $media_carousel_dots;

            var numItems = $(e).data("length");
            var config = _t.media_carousel_config.settings.v_portrait;

            config.focusOnSelect = !(numItems < 5 && $(e).data("image-type") === 'portrait' && $(e).data("contentType") === 'video');

            // Init Cards Carousel Slider
            let media_carousel = new slick_slider($media_carousel_slider, null, media_carousel_config);

            // Remove SRC from cloned iframe to resolve CORS console error
            $media_carousel_slider.on('init reInit', function() {
                _t.media_carousel_strip_clone_embeds($(this));
            });

            _t.media_carousel_strip_clone_embeds($media_carousel_slider);

            // Bind media carousel event handlers
            _t.media_carousel_bind_events();
        });
    }

    video_toggle(status, video, button){
        const $item = button.closest('.mc-item');

        if(status){
            // Mute video to allow for click to play
            video.mute();
            this.media_carousel_sync_controls($item, video);
            // Play video, the cover stays until the player reports it is playing (see onStateChange)
            video.playVideo();
        } else {
            $item.removeClass('is-playing');
            clearInterval($item.data('progress-timer'));
            $item.find('.mc-progress__bar').css('width', 0);
            // Reset video back to start
            video.seekTo(0, false);
            // Pause video
            video.pauseVideo();
            // Reset video back to start
            video.stopVideo();
            // Fade in video cover
            button.fadeIn();
        }
    }

    /* Keep the pause/mute buttons in step with the player */
    media_carousel_sync_controls($item, video) {
        $item.find('.mc-controls__mute').toggleClass('is-muted', video.isMuted())
            .attr('aria-label', video.isMuted() ? 'Unmute video' : 'Mute video');
        $item.find('.mc-controls__toggle').toggleClass('is-paused', video.getPlayerState() === 2)
            .attr('aria-label', video.getPlayerState() === 2 ? 'Play video' : 'Pause video');
    }

    /* Drive the yellow progress bar from the player's current time */
    media_carousel_track_progress($item, video) {
        clearInterval($item.data('progress-timer'));

        $item.data('progress-timer', setInterval(() => {
            const duration = video.getDuration();

            if(duration > 0) {
                $item.find('.mc-progress__bar').css('width', (video.getCurrentTime() / duration * 100) + '%');
            }
        }, 250));
    }

    media_carousel_bind_controls($item, video) {
        let _t = this;

        $item.find('.mc-controls__toggle').on('click', function() {
            video.getPlayerState() === 1 ? video.pauseVideo() : video.playVideo();
        });

        $item.find('.mc-controls__mute').on('click', function() {
            video.isMuted() ? video.unMute() : video.mute();
            _t.media_carousel_sync_controls($item, video);
        });
    }

    media_carousel_video_init() {
        // Set global context outside of loop
        let _t = this;

         const instagramScript = $('<script async>').attr('type', 'text/javascript').attr('src', '//www.instagram.com/embed.js');

        // Create YouTube Iframe API Script
        var youtube_script = $('<script>')
            .attr('type', 'text/javascript')
            .attr('src', 'https://www.youtube.com/iframe_api');

        $('head').append(youtube_script, instagramScript);

        // Loop through each slide and build video array with iframes and play button
        $('[block-name="media-carousel"]').find('.slick-slide:not(.slick-cloned)').each(function(i, e) {
            $(e).find('iframe').attr('id', 'video-' + i);

            // Check if id has been set for iframe before populating video variable
            if($(e).find('iframe').attr('id')) {
                let video = {
                    id: $(e).find('iframe').attr('id'),
                    button: $(e).find('.mc-button'),
                    item: $(e).find('.mc-item')
                }

                _t.media_carousel_config.videos.push(video);
            }
        });

        // YouTube Embed API Callback function when scripts are initalized
        window.onYouTubeIframeAPIReady = () => {
            // Loop through each iframe and initalize youtube api
            $.each(_t.media_carousel_config.videos, function(index, video) {
                _t.media_carousel_config.players.push(new YT.Player(video.id, {
                    playerVars: {
                        'playsinline': 1
                    },
                    events: {
                        'onReady': (event) => {
                            // Bind media carousel event handlers once videos are initalized
                            _t.media_carousel_bind_events();

                            video.button.on('click', function() {
                                _t.video_toggle(true, event.target, video.button);
                            });

                            _t.media_carousel_bind_controls(video.item, event.target);
                        },
                        'onStateChange': (event) => {
                            // Reset video on end
                            if(event.data === 0) _t.video_toggle(false, event.target, video.button);

                            // Hide the cover only once playback starts, so YouTube's loading chrome is never shown
                            if(event.data === 1 && !video.item.hasClass('is-playing')) {
                                video.button.fadeOut();
                                video.item.addClass('is-playing');
                                _t.media_carousel_track_progress(video.item, event.target);
                            }

                            // Reflect play / pause in the custom controls
                            if(event.data === 1 || event.data === 2) _t.media_carousel_sync_controls(video.item, event.target);
                        }
                    }
                }));
            });
        }

        $('.mc-item--instagram').hover(
            function() { //mouseenter
                $(this).addClass('active');
                $(this).find('.mc-button').css('opacity', '0');
                },
            function() { //mouseleave
                $(this).removeClass('active');
                $(this).find('.mc-button').css('opacity', '1');
            }
        );
    }

    media_carousel_bind_events(){
        // Set global context outside of loop
        let _t = this;

        $.each(_t.media_carousel_config.sliders, function(i,slider){
            // Set prev and next slick controls per block
            let $slide_prev = $(slider).parent().find('.slick-slider__navigation--prev');
            let $slide_next = $(slider).parent().find('.slick-slider__navigation--next');

            // Bind previous control to all sliders
            $slide_prev.on('click', function() {
                $(slider).slick('slickPrev');
                $(slider).slick('slickPrev');
            });

            // Bind next control to all sliders
            $slide_next.on('click', function() {
                $(slider).slick('slickNext');
                $(slider).slick('slickNext');
            });

            // If slide changes then reset active video and slide
            $(slider).on('beforeChange', function(){
                let players = _t.media_carousel_config.players;

                // Check if player has been initalized
                if(players){
                    // Loop through each player and check if current time is larger then 0
                    $.each(players, function(i,player){
                        // Reset video if larger than 0
                        if(player.getCurrentTime && player.getCurrentTime() > 0){
                            _t.video_toggle(false, player, $('#video-'+i).next());
                        }
                    });
                }
            });
        });
    }
}

$(() => {
    if($('[block-name="media-carousel"]').length) {
        let media_carousel_block = new media_carousel();
    }
});
